type AppEnv = {
  appEnv: string;
  apiBaseUrl: string;
  lineMiniAppLiffId: string;
  enableMock: boolean;
};

export function getEnv(): AppEnv {
  return {
    appEnv: import.meta.env.VITE_APP_ENV ?? "development",
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8080",
    lineMiniAppLiffId: import.meta.env.VITE_LINE_MINIAPP_LIFF_ID ?? "",
    enableMock: (import.meta.env.VITE_ENABLE_MOCK ?? "false") === "true"
  };
}